export * from "./pagination-size.component";
